import { useState } from 'react';
import { checkArray } from '../../../../Components/helper';
import useSinglePackedUnits from './useSinglePackedUnits';

export default function useDestinationPackedUnits() {
  const { calcDiffSize, calcDiffLength, limitTofourDecimal, toDec } = useSinglePackedUnits();
  const [oldPackRatio, setOldpackRatios] = useState(null);
  const [rightPacks, setRightPacks] = useState(null);

  const calculateDestinationPackedUnits = async (data) => {
    const cloneMultiSizePackedUnit = data;
    const multiDestArr = cloneMultiSizePackedUnit;
    if (checkArray(multiDestArr?.leftColumn)) {
      cloneMultiSizePackedUnit.totalSize = calcDiffSize(multiDestArr?.leftColumn);
      cloneMultiSizePackedUnit.totalLength = calcDiffLength(multiDestArr?.leftColumn);
      cloneMultiSizePackedUnit.totalDiscountPerUnit = calcDiscPrice(multiDestArr?.leftColumn);
      cloneMultiSizePackedUnit.totalPackRatio = await calcPackRatio(multiDestArr?.leftColumn);
      setOldpackRatios(await calcPackRatio(multiDestArr?.leftColumn));
      multiDestArr?.rigthColumn?.map(async (ele) => {
        const packRat = await calcPackRatio(multiDestArr?.leftColumn);
        const packRightRat = await calcPacksQuanity(multiDestArr?.rigthColumn);
        if (ele?.totalUnits) {
          if (oldPackRatio !== packRat) {
            ele.totalUnits = parseFloat(packRat) * parseFloat(ele.packsQuantity);
          } else if (rightPacks !== packRightRat) {
            ele.totalUnits = parseFloat(packRat) * parseFloat(packRightRat);
          }
        }
        return ele;
      });
      cloneMultiSizePackedUnit.totalDestPacks = await calcPacksQuanity(multiDestArr?.rigthColumn);
      setRightPacks(await calcPacksQuanity(multiDestArr?.rigthColumn));
      cloneMultiSizePackedUnit.totalDestUnits = calcTotalPacksQuantity(multiDestArr?.rigthColumn);
      cloneMultiSizePackedUnit.totalPriceBeforeDisc = calcBeforePrice(multiDestArr?.leftColumn);
      if (multiDestArr?.leftColumn) {
        for (const singular of multiDestArr.leftColumn) {
          const persentageValue = (Number(singular?.beforeDiscPrice) * Number(singular?.discount || 0)) / 100;
          singular.afterDiscPrice = singular?.beforeDiscPrice - persentageValue;
        }
      }
      cloneMultiSizePackedUnit.totalPriceAfterDisc = calcAfterPrice(multiDestArr?.leftColumn);
    }
    return cloneMultiSizePackedUnit;
  };

  function calcBeforePrice(packedRows) {
    const brforePricesTotals = packedRows.map((row) => {
      const priceBeforeDisc = row.beforeDiscPrice && !isNaN(row.beforeDiscPrice) ? parseFloat(row.beforeDiscPrice) : 0;
      let quantity = 0;
      const destiUnits = row.packRatio && !isNaN(row.packRatio) ? parseFloat(row.packRatio) : 0;

      quantity = destiUnits;
      return toDec(priceBeforeDisc * quantity);
    });
    const beforePrice = brforePricesTotals
      .map((row) => row)
      .reduce((a, b) => {
        return parseFloat(a) + parseFloat(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(beforePrice) ? 0 : limitTofourDecimal(beforePrice);
  }

  function calcDiscPrice(packedRows) {
    let discountCnt = packedRows.filter((row) => row.discount && row.discount !== '' && Number(row.discount) !== 0);
    discountCnt = discountCnt.map((val) => String(val.discount));
    discountCnt = [...new Set(discountCnt)];
    discountCnt = discountCnt?.length || 0;
    return discountCnt;
  }

  function calcAfterPrice(packedRows) {
    const afterPricesTotals = packedRows.map((row) => {
      const priceAfterDisc = row.afterDiscPrice && !isNaN(row.afterDiscPrice) ? parseFloat(row.afterDiscPrice) : 0;
      const destiUnits = row.packRatio && !isNaN(row.packRatio) ? parseFloat(row.packRatio) : 0;
      let quantity = 0;
      quantity = destiUnits;
      return toDec(priceAfterDisc * quantity);
    });
    const price = afterPricesTotals
      .map((row) => row)
      .reduce((a, b) => {
        return parseFloat(a) + parseFloat(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(price) ? 0 : limitTofourDecimal(price);
  }

  async function calcPackRatio(packedRows) {
    const rowQuantity = packedRows
      .map((row) => row.packRatio)
      .reduce((a, b) => {
        return Number(a) + Number(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(rowQuantity) ? 0 : rowQuantity;
  }

  function calcPacksQuanity(packedRows) {
    const rowQuantity = packedRows
      .map((row) => row.packsQuantity)
      .reduce((a, b) => {
        return Number(a) + Number(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(rowQuantity) ? 0 : rowQuantity;
  }

  function calcTotalPacksQuantity(packedRows) {
    const rowQuantity = packedRows
      .map((row) => row.totalUnits)
      .reduce((a, b) => {
        return Number(a) + Number(isNaN(b) ? 0 : b);
      }, 0);
    return isNaN(rowQuantity) ? 0 : rowQuantity;
  }

  return {
    calculateDestinationPackedUnits,
  };
}
